module.exports = __webpack_public_path__ + "static/media/elo.efa8d348.svg";